import client from './client';

export const tripsApi = {
  getAll(params = {}) {
    return client.get('/trips', { params });
  },
  getPublishedMap(params = {}) {
    return client.get('/trips/published-map', { params });
  },
  getById(id) {
    return client.get(`/trips/${id}`);
  },
  create(data) {
    return client.post('/trips', data);
  },
  update(id, data) {
    return client.patch(`/trips/${id}`, data);
  },
  cancel(id) {
    return client.patch(`/trips/${id}/cancel`);
  },
  delete(id) {
    return client.delete(`/trips/${id}`);
  },
};

